var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAndIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.359375,
    y: 0.9375,
    width: 22.6406,
    height: 22.6406,
    rx: 4.11648,
    fill: "#DAE4F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.02917 8.05859V16.2919H13.2042C14.296 16.2919 15.3431 15.8582 16.1151 15.0862C16.8871 14.3142 17.3208 13.2671 17.3208 12.1753C17.3208 11.0835 16.8871 10.0364 16.1151 9.26434C15.3431 8.49231 14.296 8.05859 13.2042 8.05859H7.02917ZM8.05834 9.08776H13.2042C14.023 9.08776 14.8083 9.41305 15.3874 9.99207C15.9664 10.5711 16.2917 11.3564 16.2917 12.1753C16.2917 12.9941 15.9664 13.7794 15.3874 14.3585C14.8083 14.9375 14.023 15.2628 13.2042 15.2628H8.05834V9.08776Z",
    fill: "#0B1C56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndIcon);
export default __webpack_public_path__ + "static/media/andIcon.59aad581471bf2a493e39fbfe7ef89c8.svg";
export { ForwardRef as ReactComponent };